import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOhgarCategoryBlocksComponent } from './custom-ohgar-category-blocks.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {CustomItemCategoryBlocksComponentModule} from '../custom-item-category-blocks-component/custom-item-category-blocks-component.module';

@NgModule({
  declarations: [CustomOhgarCategoryBlocksComponent],
  exports: [CustomOhgarCategoryBlocksComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomItemCategoryBlocksComponentModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OhgarCategoryBlocksComponent: {
          component: CustomOhgarCategoryBlocksComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomOhgarCategoryBlocksModule { }
